import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import { MuiThemeProvider } from '@material-ui/core/styles';
import { baseStyles, baseColors } from "../../baseStyles";
import {
  passwordManager, getGIZprivileges, createNewEmployee
} from "../../general_functions/employeeFunctions";
import UserRoles from "./userRoles";

export default class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      passwordChecker: true,
      gizPrivileges: [],
    };
  }

  cleanFormHandler(){
    this.setState({
      username: '',
      password: '',
      confPassword: '',
      email: '',
      gizPrivileges: []
    })
  };

  handleSaveButton(e) {
    e.preventDefault();

    const state = this.state;

    //Check if the password match.
    if (state.password != state.confPassword) {
      this.props.handleSnackbar(
        "Passwords not much"
      );
      return;
    }

    //Check if form's files are not empty.
    if (
      state.userName == "" ||
      state.password == "" ||
      state.confPassword == "" ||
      state.email == ""
    ) {
      this.props.handleSnackbar(
        "Fiels should not empty"
      );
      return;
    }

    let rolesId = [];

    state.gizPrivileges.map((role, index) => {
      rolesId.push(parseInt(role.sortNO));
    });

    let data = {
      username: state.userName,
      password: state.password,
      email: state.email,
      roles: rolesId,
    };

    createNewEmployee(data, res => {
      if (res) {
        this.props.handleSnackbar(
          "User has been saved succesfuly!"
        );
      } else {
        this.props.handleSnackbar(
          "This user is already exist, please chnage your info and try again!"
        );
      }
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    return (
      <div>
        <div style={{ padding: "0 1.8em" }}>
          <div>
            <h3 style={{
              color: baseColors.bgBlue,
              paddingTop: 24}}>
              Create new user
            </h3>
          </div>
          <div>
            <form>
              <div>
                <TextField
                  style={baseStyles.textField}
                  label="Username"
                  value={this.state.username}
                  onChange={this.handleChange('userName')}
                  required
                />
                <TextField
                  style={baseStyles.textField}
                  value={this.state.email}
                  onChange={this.handleChange('email')}
                  type="email"
                  label="Email"
                />
                <TextField
                  style={baseStyles.textField}
                  label="Password"
                  type="password"
                  autoComplete="current-password"
                  value={this.state.password}
                  onChange={this.handleChange('password')}
                  required
                />
                <TextField
                  style={baseStyles.textField}
                  value={this.state.confPassword}
                  onChange={this.handleChange('confPassword')}
                  label="Conferm-password"
                  type="password"
                  required
                />
              </div>
              <br/>

              {/* <div style={styles.userRolColumn}>
                <UserRoles
                  roleTitle={"User privileges"}
                  privileges={getGIZprivileges()}
                  getAllUserPrivilege={array =>
                    this.setState({ gizPrivileges: array })
                  }
                />
              </div> */}
              <div>
                <br />
                <Button
                  style={baseStyles.minButton}
                  color="primary"
                  onClick={this.handleSaveButton.bind(this)}>
                  Save
                </Button>
                <Button
                  style={baseStyles.minButton}
                  color="secondary"
                  onClick={this.cleanFormHandler.bind(this)}>
                  Clear
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
};
